// Translations for the Reports page (Reports.js).
const reportsDict = [
  { en: "Members Report", sw: "Ripoti ya Wanachama" },
  { en: "View all member statistics including registrations, status changes, and demographics", sw: "Angalia takwimu zote za wanachama zikiwemo usajili, mabadiliko ya hali, na demografia" },
  { en: "Contributions Report", sw: "Ripoti ya Michango" },
  { en: "Monthly contribution summaries, collection rates, and payment status", sw: "Muhtasari wa michango ya kila mwezi, viwango vya ukusanyaji, na hali ya malipo" },
  { en: "Loans Report", sw: "Ripoti ya Mikopo" },
  { en: "Loan portfolio overview, disbursements, recoveries, and default rates", sw: "Muhtasari wa mikopo, utoaji, urejeshaji, na viwango vya kutolipa" },
  { en: "Financial Summary", sw: "Muhtasari wa Fedha" },
  { en: "Complete financial overview with income, expenditure, and balances", sw: "Muhtasari kamili wa fedha ukiwemo mapato, matumizi, na masalio" },
  { en: "Excel export feature coming soon", sw: "Huduma ya kuhamisha data kwenda Excel inakuja hivi karibuni" },
  { en: "PDF export feature coming soon", sw: "Huduma ya kuhamisha data kwenda PDF inakuja hivi karibuni" },
  { en: "Reports & Analytics", sw: "Ripoti na Uchambuzi" },
  { en: "Excel", sw: "Excel" },
  { en: "PDF", sw: "PDF" },
  { en: "Year:", sw: "Mwaka:" },
  { en: "Export Excel", sw: "Hamisha kwenda Excel" },
  { en: "Export PDF", sw: "Hamisha kwenda PDF" },
  { en: "Member #", sw: "Namba ya Mwanachama" },
  { en: "Name", sw: "Jina" },
  { en: "Phone", sw: "Simu" },
  { en: "Status", sw: "Hali" },
  { en: "Joined", sw: "Alijiunga" },
  { en: "contributions", sw: "michango" },
  { en: "Count", sw: "Idadi" },
  { en: "Total Principal", sw: "Jumla ya Mkopo Msingi" },
  { en: "Total Balance", sw: "Jumla ya Salio" },
  { en: "Select a report to generate", sw: "Chagua ripoti ili kuzalisha" },
];

export default reportsDict;
